import * as actionTypes from "../actions";

import * as constants from "../../constants";
import {addItemInListOfItems, deleteItemByIdInListOfItems, updateItemInListOfItems} from "../../helpers";
import { WORKSPACE_VIEWS } from "@/constants/booker";
import { SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING } from "@/constants/settings";


const initialState = {
    restaurantSettings: {
        id: null,
        reservation_enabled: false,
        shop_enabled: false,
        stripe_account_id: false,
        online_payment_enabled: false,
        name: constants.RESTAURANT_NAME_TEXT,
        address: constants.RESTAURANT_ADDRESS_TEXT,
        phone: "",
        email: "",
        website: "",
        latitude: 50.7459,
        longitude: 3.2193,
        zoom: 16,
        logo: null,
        banner: null,
        online: false,
        reservation_duration: "02:00:00",
        reservation_before_duration: "01:00:00",
        duration_before_service: true,
        show_cake: false,
        cake_before_duration: "1 00:00:00",
        show_stroller: false,
        show_highchair: false,
        show_reduced_mobility: false,
        show_terrace: true,
        terrace_message: null,
        global_message: "",
        show_global_message: false,
        modules: {},
        country: "BE",
    },
    getRestaurantSettingsLoading: false,
    getRestaurantSettingsError: null,
    updateRestaurantSettingsLoading: false,
    updateRestaurantSettingsError: null,

    activateStripeLoading: false,
    activateStripeError: null,

    deactivateStripeLoading: false,
    deactivateStripeError: null,

    emailSettings: {
        id: null,
        email: "noreply@ses.barestho.com",
        email_sender: "",
        email_signature: "",
        new_reservation: true,
        reservation_cancelled: true,
        customer_reservation_pending: true,
        customer_reservation_confirmed: true,
    },
    getEmailSettingsLoading: false,
    getEmailSettingsError: null,
    updateEmailSettingsLoading: false,
    updateEmailSettingsError: null,

    appSettings: {
        sound_notification: true,
        active_reservation_view: true,
        active_floorplan_edition_view: false,
        active_floorplan_booking_view: false,
        
        show_old_reservations: true,
        show_overlap_alert: true,
        
        floorplan_show_customer_name: true,
        floorplan_show_party_size: true,
        floorplan_show_start_time: true,
        floorplan_show_links: true,
        [SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING]: {
            [WORKSPACE_VIEWS.LIST]: false,
            [WORKSPACE_VIEWS.TIMELINE]: false,
            [WORKSPACE_VIEWS.FLOORPLAN]: false,
        },
        current_workspace_view: WORKSPACE_VIEWS.LIST,
    },

    openingHourModalVisible: false,
    
    openingHours: [],
    getOpeningHoursLoading: false,
    getOpeningHoursError: null,
    addOpeningHourLoading: false,
    addOpeningHourError: null,
    updateOpeningHourLoading: false,
    updateOpeningHourError: null,
    deleteOpeningHourLoading: false,
    deleteOpeningHourError: null,

    customEvents: [],
    getCustomEventsLoading: false,
    getCustomEventsError: null,
    addCustomEventLoading: false,
    addCustomEventError: null,
    updateCustomEventLoading: false,
    updateCustomEventError: null,
    deleteCustomEventLoading: false,
    deleteCustomEventError: null,

    messageSamples: [],
    getMessageSamplesLoading: false,
    getMessageSamplesError: null,
    addMessageSampleLoading: false,
    addMessageSampleError: null,
    updateMessageSampleLoading: false,
    updateMessageSampleError: null,
    deleteMessageSampleLoading: false,
    deleteMessageSampleError: null,

    messageSamplesTypes: [],
    getMessageSamplesTypesLoading: false,
    getMessageSamplesTypesError: null,

    reservationConditions: [],
    getReservationConditionsLoading: false,
    getReservationConditionsError: null,
    addReservationConditionLoading: false,
    addReservationConditionError: null,
    updateReservationConditionLoading: false,
    updateReservationConditionError: null,
    deleteReservationConditionLoading: false,
    deleteReservationConditionError: null,

    specialOptions: [],
    getSpecialOptionsLoading: false,
    getSpecialOptionsError: null,
    addSpecialOptionLoading: false,
    addSpecialOptionError: null,
    updateSpecialOptionLoading: false,
    updateSpecialOptionError: null,
    deleteSpecialOptionLoading: false,
    deleteSpecialOptionError: null,

    specialOptionCategories: [],
    lastSpecialOptionCategoryCreated: null,
    getSpecialOptionCategoriesLoading: false,
    getSpecialOptionCategoriesError: null,
    addSpecialOptionCategoryLoading: false,
    addSpecialOptionCategoryError: null,
    updateSpecialOptionCategoryLoading: false,
    updateSpecialOptionCategoryError: null,
    deleteSpecialOptionCategoryLoading: false,
    deleteSpecialOptionCategoryError: null,
};

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {

        // GET RESTAURANT SETTINGS
        case actionTypes.GET_RESTAURANT_SETTINGS_REQUEST:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading
            };
        case actionTypes.GET_RESTAURANT_SETTINGS_SUCCESS:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading,
                getRestaurantSettingsError: action.error,
                restaurantSettings: action.restaurantSettings
            };
        case actionTypes.GET_RESTAURANT_SETTINGS_ERROR:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading,
                getRestaurantSettingsError: action.error
            };

        // UPDATE RESTAURANT SETTINGS
        case actionTypes.UPDATE_RESTAURANT_SETTINGS_REQUEST:
            return {
                ...state,
                updateRestaurantSettingsLoading: action.loading
            };
        case actionTypes.UPDATE_RESTAURANT_SETTINGS_SUCCESS:
            return {
                ...state,
                updateRestaurantSettingsLoading: action.loading,
                updateRestaurantSettingsError: action.error,
                restaurantSettings: action.restaurantSettings
            };
        case actionTypes.UPDATE_RESTAURANT_SETTINGS_ERROR:
            return {
                ...state,
                updateRestaurantSettingsLoading: action.loading,
                updateRestaurantSettingsError: action.error
            };

        // GET EMAIL SETTINGS
        case actionTypes.GET_EMAIL_SETTINGS_REQUEST:
            return {
                ...state,
                getEmailSettingsLoading: action.loading
            };
        case actionTypes.GET_EMAIL_SETTINGS_SUCCESS:
            return {
                ...state,
                getEmailSettingsLoading: action.loading,
                getEmailSettingsError: action.error,
                emailSettings: action.emailSettings
            };
        case actionTypes.GET_EMAIL_SETTINGS_ERROR:
            return {
                ...state,
                getEmailSettingsLoading: action.loading,
                getEmailSettingsError: action.error
            };

        // UPDATE EMAIL SETTINGS
        case actionTypes.UPDATE_EMAIL_SETTINGS_REQUEST:
            return {
                ...state,
                updateEmailSettingsLoading: action.loading
            };
        case actionTypes.UPDATE_EMAIL_SETTINGS_SUCCESS:
            return {
                ...state,
                updateEmailSettingsLoading: action.loading,
                updateEmailSettingsError: action.error,
                emailSettings: action.emailSettings
            };
        case actionTypes.UPDATE_EMAIL_SETTINGS_ERROR:
            return {
                ...state,
                updateEmailSettingsLoading: action.loading,
                updateEmailSettingsError: action.error
            };
        
        // GET APP SETTINGS
        case actionTypes.GET_APP_SETTINGS:
            return {
                ...state,
                appSettings: {
                    ...initialState.appSettings,
                    ...(action.appSettings ?? {})
                }
            };

        // UPDATE APP SETTINGS
        case actionTypes.UPDATE_APP_SETTINGS:
            return {
                ...state,
                appSettings: {
                    ...initialState.appSettings,
                    ...action.appSettings,
                },
            };

        // ACTIVATE STRIPE
        case actionTypes.ACTIVATE_STRIPE_REQUEST:
            return {
                ...state,
                activateStripeLoading: action.loading
            };
        case actionTypes.ACTIVATE_STRIPE_SUCCESS:
            return {
                ...state,
                activateStripeLoading: action.loading,
                activateStripeError: action.error,
                restaurantSettings: {...state.restaurantSettings, stripe_account_id: action.connected_account_id}
            };
        case actionTypes.ACTIVATE_STRIPE_ERROR:
            return {
                ...state,
                activateStripeLoading: action.loading,
                activateStripeError: action.error
            };

        // DEACTIVATE STRIPE
        case actionTypes.DEACTIVATE_STRIPE_REQUEST:
            return {
                ...state,
                deactivateStripeLoading: action.loading
            };
        case actionTypes.DEACTIVATE_STRIPE_SUCCESS:
            return {
                ...state,
                deactivateStripeLoading: action.loading,
                deactivateStripeError: action.error,
                restaurantSettings: {...state.restaurantSettings, stripe_account_id: false}
            };
        case actionTypes.DEACTIVATE_STRIPE_ERROR:
            return {
                ...state,
                deactivateStripeLoading: action.loading,
                deactivateStripeError: action.error
            };

        // TOGGLE OPENING HOUR MODAL
        case actionTypes.TOGGLE_OPENING_HOUR_MODAL:
            return {
                ...state,
                openingHourModalVisible: !state.openingHourModalVisible
            };

        // GET OPENING_HOURS
        case actionTypes.GET_OPENING_HOURS_REQUEST:
            return {
                ...state,
                getOpeningHoursLoading: action.loading
            };
        case actionTypes.GET_OPENING_HOURS_SUCCESS:
            return {
                ...state,
                getOpeningHoursLoading: action.loading,
                getOpeningHoursError: action.error,
                openingHours: action.openingHours
            };
        case actionTypes.GET_OPENING_HOURS_ERROR:
            return {
                ...state,
                getOpeningHoursLoading: action.loading,
                getOpeningHoursError: action.error
            };

        // ADD OPENING_HOUR
        case actionTypes.ADD_OPENING_HOUR_REQUEST:
            return {
                ...state,
                addOpeningHourLoading: action.loading
            };
        case actionTypes.ADD_OPENING_HOUR_SUCCESS:
            return {
                ...state,
                addOpeningHourLoading: action.loading,
                addOpeningHourError: action.error,
                openingHours: addItemInListOfItems(state.openingHours, action.openingHour)
            };
        case actionTypes.ADD_OPENING_HOUR_ERROR:
            return {
                ...state,
                addOpeningHourLoading: action.loading,
                addOpeningHourError: action.error
            };

        // UPDATE OPENING_HOUR
        case actionTypes.UPDATE_OPENING_HOUR_REQUEST:
            return {
                ...state,
                updateOpeningHourLoading: action.loading
            };
        case actionTypes.UPDATE_OPENING_HOUR_SUCCESS:
            return {
                ...state,
                updateOpeningHourLoading: action.loading,
                updateOpeningHourError: action.error,
                openingHours: updateItemInListOfItems(state.openingHours, action.openingHour)
            };
        case actionTypes.UPDATE_OPENING_HOUR_ERROR:
            return {
                ...state,
                updateOpeningHourLoading: action.loading,
                updateOpeningHourError: action.error
            };

        // DELETE OPENING_HOUR
        case actionTypes.DELETE_OPENING_HOUR_REQUEST:
            return {
                ...state,
                deleteOpeningHourLoading: action.loading
            };
        case actionTypes.DELETE_OPENING_HOUR_SUCCESS:
            return {
                ...state,
                deleteOpeningHourLoading: action.loading,
                deleteOpeningHourError: action.error,
                openingHours: deleteItemByIdInListOfItems(state.openingHours, action.openingHourId)
            };
        case actionTypes.DELETE_OPENING_HOUR_ERROR:
            return {
                ...state,
                deleteOpeningHourLoading: action.loading,
                deleteOpeningHourError: action.error
            };

        // GET CUSTOM EVENTS
        case actionTypes.GET_CUSTOM_EVENTS_REQUEST:
            return {
                ...state,
                getCustomEventsLoading: action.loading
            };
        case actionTypes.GET_CUSTOM_EVENTS_SUCCESS:
            return {
                ...state,
                getCustomEventsLoading: action.loading,
                getCustomEventsError: action.error,
                customEvents: action.customEvents
            };
        case actionTypes.GET_CUSTOM_EVENTS_ERROR:
            return {
                ...state,
                getCustomEventsLoading: action.loading,
                getCustomEventsError: action.error
            };

        // ADD CUSTOM_EVENT
        case actionTypes.ADD_CUSTOM_EVENT_REQUEST:
            return {
                ...state,
                addCustomEventLoading: action.loading
            };
        case actionTypes.ADD_CUSTOM_EVENT_SUCCESS:
            return {
                ...state,
                addCustomEventLoading: action.loading,
                addCustomEventError: action.error,
                customEvents: addItemInListOfItems(state.customEvents, action.customEvent)
            };
        case actionTypes.ADD_CUSTOM_EVENT_ERROR:
            return {
                ...state,
                addCustomEventLoading: action.loading,
                addCustomEventError: action.error
            };

        // UPDATE CUSTOM_EVENT
        case actionTypes.UPDATE_CUSTOM_EVENT_REQUEST:
            return {
                ...state,
                updateCustomEventLoading: action.loading
            };
        case actionTypes.UPDATE_CUSTOM_EVENT_SUCCESS:
            return {
                ...state,
                updateCustomEventLoading: action.loading,
                updateCustomEventError: action.error,
                customEvents: updateItemInListOfItems(state.customEvents, action.customEvent)
            };
        case actionTypes.UPDATE_CUSTOM_EVENT_ERROR:
            return {
                ...state,
                updateCustomEventLoading: action.loading,
                updateCustomEventError: action.error
            };

        // DELETE CUSTOM_EVENT
        case actionTypes.DELETE_CUSTOM_EVENT_REQUEST:
            return {
                ...state,
                deleteCustomEventLoading: action.loading
            };
        case actionTypes.DELETE_CUSTOM_EVENT_SUCCESS:
            return {
                ...state,
                deleteCustomEventLoading: action.loading,
                deleteCustomEventError: action.error,
                customEvents: deleteItemByIdInListOfItems(state.customEvents, action.customEventId)
            };
        case actionTypes.DELETE_CUSTOM_EVENT_ERROR:
            return {
                ...state,
                deleteCustomEventLoading: action.loading,
                deleteCustomEventError: action.error
            };

        // GET MESSAGES SAMPLES
        case actionTypes.GET_MESSAGE_SAMPLES_REQUEST:
            return {
                ...state,
                getMessageSamplesLoading: true,
            };
        
        case actionTypes.GET_MESSAGE_SAMPLES_SUCCESS:
            return {
                ...state,
                getMessageSamplesLoading: false,
                getMessageSamplesError: null,
                messageSamples: action.data,
            };
        
        case actionTypes.GET_MESSAGE_SAMPLES_ERROR:
            return {
                ...state,
                getMessageSamplesLoading: false,
                getMessageSamplesError: action.error,
            };

        // ADD MESSAGE SAMPLE
        case actionTypes.ADD_MESSAGE_SAMPLE_REQUEST:
            return {
                ...state,
                addMessageSampleLoading: true,
            };
        
        case actionTypes.ADD_MESSAGE_SAMPLE_SUCCESS:
            return {
                ...state,
                addMessageSampleLoading: false,
                addMessageSampleError: null,
                messageSamples: addItemInListOfItems(state.messageSamples, action.data),
            };
        
        case actionTypes.ADD_MESSAGE_SAMPLE_ERROR:
            return {
                ...state,
                addMessageSampleLoading: false,
                addMessageSampleError: action.error,
            };

        // UPDATE MESSAGE SAMPLE
        case actionTypes.UPDATE_MESSAGE_SAMPLE_REQUEST:
            return {
                ...state,
                updateMessageSampleLoading: true,
            };
        
        case actionTypes.UPDATE_MESSAGE_SAMPLE_SUCCESS:
            return {
                ...state,
                updateMessageSampleLoading: false,
                updateMessageSampleError: null,
                messageSamples: updateItemInListOfItems(state.messageSamples, action.data),
            };
        
        case actionTypes.UPDATE_MESSAGE_SAMPLE_ERROR:
            return {
                ...state,
                updateMessageSampleLoading: false,
                updateMessageSampleError: action.error,
            };
        
        // DELETE MESSAGE SAMPLE
        case actionTypes.DELETE_MESSAGE_SAMPLE_REQUEST:
            return {
                ...state,
                deleteMessageSampleLoading: true,
            };
        
        case actionTypes.DELETE_MESSAGE_SAMPLE_SUCCESS:
            return {
                ...state,
                deleteMessageSampleLoading: false,
                deleteMessageSampleError: null,
                messageSamples: deleteItemByIdInListOfItems(state.messageSamples, action.id),
            };
        
        case actionTypes.DELETE_MESSAGE_SAMPLE_ERROR:
            return {
                ...state,
                deleteMessageSampleLoading: false,
                deleteMessageSampleError: action.error,
            };
        
        // GET MESSAGES SAMPLES
        case actionTypes.GET_RESERVATION_CONDITIONS_REQUEST:
            return {
                ...state,
                getReservationConditionsLoading: true,
            };
        
        case actionTypes.GET_RESERVATION_CONDITIONS_SUCCESS:
            return {
                ...state,
                getReservationConditionsLoading: false,
                getReservationConditionsError: null,
                reservationConditions: action.data,
            };
        
        case actionTypes.GET_RESERVATION_CONDITIONS_ERROR:
            return {
                ...state,
                getReservationConditionsLoading: false,
                getReservationConditionsError: action.error,
            };

        // ADD MESSAGE SAMPLE
        case actionTypes.ADD_RESERVATION_CONDITION_REQUEST:
            return {
                ...state,
                addReservationConditionLoading: true,
            };
        
        case actionTypes.ADD_RESERVATION_CONDITION_SUCCESS:
            return {
                ...state,
                addReservationConditionLoading: false,
                addReservationConditionError: null,
                reservationConditions: addItemInListOfItems(state.reservationConditions, action.data),
            };
        
        case actionTypes.ADD_RESERVATION_CONDITION_ERROR:
            return {
                ...state,
                addReservationConditionLoading: false,
                addReservationConditionError: action.error,
            };

        // UPDATE MESSAGE SAMPLE
        case actionTypes.UPDATE_RESERVATION_CONDITION_REQUEST:
            return {
                ...state,
                updateReservationConditionLoading: true,
            };
        
        case actionTypes.UPDATE_RESERVATION_CONDITION_SUCCESS:
            return {
                ...state,
                updateReservationConditionLoading: false,
                updateReservationConditionError: null,
                reservationConditions: updateItemInListOfItems(state.reservationConditions, action.data),
            };
        
        case actionTypes.UPDATE_RESERVATION_CONDITION_ERROR:
            return {
                ...state,
                updateReservationConditionLoading: false,
                updateReservationConditionError: action.error,
            };
        
        // DELETE MESSAGE SAMPLE
        case actionTypes.DELETE_RESERVATION_CONDITION_REQUEST:
            return {
                ...state,
                deleteReservationConditionLoading: true,
            };
        
        case actionTypes.DELETE_RESERVATION_CONDITION_SUCCESS:
            return {
                ...state,
                deleteReservationConditionLoading: false,
                deleteReservationConditionError: null,
                reservationConditions: deleteItemByIdInListOfItems(state.reservationConditions, action.id),
            };
        
        case actionTypes.DELETE_RESERVATION_CONDITION_ERROR:
            return {
                ...state,
                deleteReservationConditionLoading: false,
                deleteReservationConditionError: action.error,
            };



        // GET MESSAGES SAMPLES
        case actionTypes.GET_SPECIAL_OPTIONS_REQUEST:
            return {
                ...state,
                getSpecialOptionsLoading: true,
            };
        
        case actionTypes.GET_SPECIAL_OPTIONS_SUCCESS:
            return {
                ...state,
                getSpecialOptionsLoading: false,
                getSpecialOptionsError: null,
                specialOptions: action.data,
            };
        
        case actionTypes.GET_SPECIAL_OPTIONS_ERROR:
            return {
                ...state,
                getSpecialOptionsLoading: false,
                getSpecialOptionsError: action.error,
            };

        // ADD MESSAGE SAMPLE
        case actionTypes.ADD_SPECIAL_OPTION_REQUEST:
            return {
                ...state,
                addSpecialOptionLoading: true,
            };
        
        case actionTypes.ADD_SPECIAL_OPTION_SUCCESS:
            return {
                ...state,
                addSpecialOptionLoading: false,
                addSpecialOptionError: null,
                specialOptions: addItemInListOfItems(state.specialOptions, action.data),
            };
        
        case actionTypes.ADD_SPECIAL_OPTION_ERROR:
            return {
                ...state,
                addSpecialOptionLoading: false,
                addSpecialOptionError: action.error,
            };

        // UPDATE MESSAGE SAMPLE
        case actionTypes.UPDATE_SPECIAL_OPTION_REQUEST:
            return {
                ...state,
                updateSpecialOptionLoading: true,
            };
        
        case actionTypes.UPDATE_SPECIAL_OPTION_SUCCESS:
            return {
                ...state,
                updateSpecialOptionLoading: false,
                updateSpecialOptionError: null,
                specialOptions: updateItemInListOfItems(state.specialOptions, action.data),
            };
        
        case actionTypes.UPDATE_SPECIAL_OPTION_ERROR:
            return {
                ...state,
                updateSpecialOptionLoading: false,
                updateSpecialOptionError: action.error,
            };
        
        // DELETE MESSAGE SAMPLE
        case actionTypes.DELETE_SPECIAL_OPTION_REQUEST:
            return {
                ...state,
                deleteSpecialOptionLoading: true,
            };
        
        case actionTypes.DELETE_SPECIAL_OPTION_SUCCESS:
            return {
                ...state,
                deleteSpecialOptionLoading: false,
                deleteSpecialOptionError: null,
                specialOptions: deleteItemByIdInListOfItems(state.specialOptions, action.id),
            };
        
        case actionTypes.DELETE_SPECIAL_OPTION_ERROR:
            return {
                ...state,
                deleteSpecialOptionLoading: false,
                deleteSpecialOptionError: action.error,
            };

        case actionTypes.GET_SPECIAL_OPTION_CATEGORIES_REQUEST:
            return {
                ...state,
                getSpecialOptionCategoriesLoading: true,
            };
        
        case actionTypes.GET_SPECIAL_OPTION_CATEGORIES_SUCCESS:
            return {
                ...state,
                getSpecialOptionCategoriesLoading: false,
                getSpecialOptionCategoriesError: null,
                specialOptionCategories: action.data,
            };
        
        case actionTypes.GET_SPECIAL_OPTION_CATEGORIES_ERROR:
            return {
                ...state,
                getSpecialOptionCategoriesLoading: false,
                getSpecialOptionCategoriesError: action.error,
            };

        // ADD MESSAGE SAMPLE
        case actionTypes.ADD_SPECIAL_OPTION_CATEGORY_REQUEST:
            return {
                ...state,
                addSpecialOptionCategoryLoading: true,
            };
        
        case actionTypes.ADD_SPECIAL_OPTION_CATEGORY_SUCCESS:
            return {
                ...state,
                addSpecialOptionCategoryLoading: false,
                addSpecialOptionCategoryError: null,
                lastSpecialOptionCategoryCreated: action.data,
                specialOptionCategories: addItemInListOfItems(state.specialOptionCategories, action.data),
            };
        
        case actionTypes.ADD_SPECIAL_OPTION_CATEGORY_ERROR:
            return {
                ...state,
                addSpecialOptionCategoryLoading: false,
                addSpecialOptionCategoryError: action.error,
            };

        // UPDATE MESSAGE SAMPLE
        case actionTypes.UPDATE_SPECIAL_OPTION_CATEGORY_REQUEST:
            return {
                ...state,
                updateSpecialOptionCategoryLoading: true,
            };
        
        case actionTypes.UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS:
            return {
                ...state,
                updateSpecialOptionCategoryLoading: false,
                updateSpecialOptionCategoryError: null,
                specialOptionCategories: updateItemInListOfItems(state.specialOptionCategories, action.data),
            };
        
        case actionTypes.UPDATE_SPECIAL_OPTION_CATEGORY_ERROR:
            return {
                ...state,
                updateSpecialOptionCategoryLoading: false,
                updateSpecialOptionCategoryError: action.error,
            };
        
        // DELETE MESSAGE SAMPLE
        case actionTypes.DELETE_SPECIAL_OPTION_CATEGORY_REQUEST:
            return {
                ...state,
                deleteSpecialOptionCategoryLoading: true,
            };
        
        case actionTypes.DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS:
            return {
                ...state,
                deleteSpecialOptionCategoryLoading: false,
                deleteSpecialOptionCategoryError: null,
                specialOptionCategories: deleteItemByIdInListOfItems(state.specialOptionCategories, action.id),
            };
        
        case actionTypes.DELETE_SPECIAL_OPTION_CATEGORY_ERROR:
            return {
                ...state,
                deleteSpecialOptionCategoryLoading: false,
                deleteSpecialOptionCategoryError: action.error,
            };

        
        default:
            return state;
    }
};

export default settingsReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/settings.js